var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.630469 7.00002C0.630469 10.5144 3.48691 13.3709 7.0013 13.3709C10.5157 13.3709 13.3721 10.5144 13.3721 7.00002C13.3721 3.48563 10.5157 0.629187 7.0013 0.629187C3.48691 0.629187 0.630469 3.48563 0.630469 7.00002ZM1.70547 7.00002C1.70547 4.08025 4.08153 1.70419 7.0013 1.70419C9.92107 1.70419 12.2971 4.08025 12.2971 7.00002C12.2971 9.91979 9.92107 12.2959 7.0013 12.2959C4.08153 12.2959 1.70547 9.91979 1.70547 7.00002Z",
    fill: "#293A47",
    stroke: "#293A47",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0839 8.23504L7.08394 8.23506L8.89024 9.31302C8.97894 9.37146 9.07415 9.39253 9.16518 9.39253C9.34565 9.39253 9.52346 9.2988 9.62915 9.12969L9.62919 9.12972L9.63073 9.12708C9.77964 8.8718 9.70311 8.54148 9.4435 8.38973C9.44335 8.38965 9.44321 8.38956 9.44307 8.38948L7.63559 7.31082L7.6356 7.31082L7.63456 7.31021C7.56524 7.26996 7.4872 7.18295 7.42554 7.07455C7.36396 6.96627 7.32852 6.85385 7.32852 6.77253V4.38086C7.32852 4.08646 7.08541 3.84336 6.79102 3.84336C6.49662 3.84336 6.25352 4.08646 6.25352 4.38086V6.77253C6.25352 7.32681 6.60445 7.94862 7.0839 8.23504Z",
    fill: "#293A47",
    stroke: "#293A47",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/HistoryIcon.3250af521a3144265e12ef7f4b78014e.svg";
export { ForwardRef as ReactComponent };